<template>
  <div class="view-container">
    <div class="mail-layout">
      <div class="folder-panel">
        <div class="panel-header"><button @click="$emit('navigate', 'mailExtCompose')" class="btn btn-primary btn-sm" style="width:100%"><i class="fas fa-pen"></i> 写邮件</button></div>
        <div class="folder-list">
          <div :class="['folder-item', { active: folder === 'inbox' }]" @click="folder = 'inbox'"><i class="fas fa-inbox"></i><span>收件箱</span><span class="folder-count">{{ extInbox.length }}</span></div>
          <div :class="['folder-item', { active: folder === 'sent' }]" @click="folder = 'sent'"><i class="fas fa-paper-plane"></i><span>已发送</span><span class="folder-count">{{ extSent.length }}</span></div>
          <div :class="['folder-item', { active: folder === 'drafts' }]" @click="folder = 'drafts'"><i class="fas fa-file-alt"></i><span>草稿箱</span><span class="folder-count">{{ extDrafts.length }}</span></div>
          <div :class="['folder-item', { active: folder === 'spam' }]" @click="folder = 'spam'"><i class="fas fa-exclamation-triangle"></i><span>垃圾邮件</span><span class="folder-count">{{ extSpam.length }}</span></div>
        </div>
        <div class="fetch-section">
          <button @click="fetchMails" class="btn btn-default btn-sm" style="width:100%"><i class="fas fa-sync-alt"></i> 获取邮件 (POP3)</button>
          <div v-if="fetching" class="fetch-status">正在连接 POP3 服务器...</div>
          <div v-if="lastFetch" class="fetch-status">上次获取: {{ lastFetch }}</div>
        </div>
      </div>

      <div class="mail-list-panel">
        <div class="list-header"><input v-model="searchQuery" class="form-control form-control-sm" placeholder="搜索邮件..."></div>
        <div class="mail-list">
          <div v-for="m in filteredMails" :key="m.id" :class="['mail-item', { unread: !m.read && folder === 'inbox', selected: selectedMail && selectedMail.id === m.id }]" @click="openMailDetail(m)">
            <div class="mail-avatar" :style="{ background: m.avatarColor }">{{ m.avatar }}</div>
            <div class="mail-info">
              <div class="mail-top"><span class="mail-from">{{ folder === 'sent' ? '发给: ' + (m.toName || m.to) : (m.fromName || m.from) }}</span><span class="mail-time">{{ m.time }}</span></div>
              <div class="mail-subject">{{ m.subject }}</div>
              <div class="mail-preview">{{ m.preview }}</div>
            </div>
            <span v-if="!m.read && folder === 'inbox'" class="unread-dot"></span>
          </div>
          <div v-if="filteredMails.length === 0" class="empty-list">暂无邮件，点击"获取邮件"从 POP3 服务器拉取</div>
        </div>
      </div>

      <div class="mail-detail-panel" v-if="selectedMail">
        <div class="detail-header"><h4>{{ selectedMail.subject }}</h4><button @click="selectedMail = null" class="close-btn"><i class="fas fa-times"></i></button></div>
        <div class="detail-meta">
          <div class="avatar large" :style="{ background: selectedMail.avatarColor }">{{ selectedMail.avatar }}</div>
          <div class="meta-info">
            <div class="meta-row"><label>发件人: </label><span>{{ selectedMail.from }}</span></div>
            <div class="meta-row"><label>收件人: </label><span>{{ selectedMail.to }}</span></div>
            <div class="meta-row"><label>时间: </label><span>{{ selectedMail.fullTime }}</span></div>
            <div v-if="selectedMail.attachments && selectedMail.attachments.length" class="meta-row"><label>附件: </label><span class="attach-list"><span v-for="a in selectedMail.attachments" :key="a" class="attach-item"><i class="fas fa-paperclip"></i> {{ a }}</span></span></div>
          </div>
        </div>
        <div class="detail-body" v-html="selectedMail.body"></div>
        <div class="detail-actions">
          <button @click="replyMail(selectedMail)" class="btn btn-primary btn-sm"><i class="fas fa-reply"></i> 回复</button>
          <button @click="forwardMail(selectedMail)" class="btn btn-default btn-sm"><i class="fas fa-share"></i> 转发</button>
          <button @click="deleteMail(selectedMail)" class="btn btn-danger btn-sm"><i class="fas fa-trash"></i> 删除</button>
        </div>
      </div>
      <div v-else class="mail-detail-panel empty-detail"><div class="empty-state"><i class="fas fa-envelope-open-text"></i><p>选择一封邮件查看详情</p></div></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
const emit = defineEmits(['navigate'])
const folder = ref('inbox')
const searchQuery = ref('')
const selectedMail = ref(null)
const fetching = ref(false)
const lastFetch = ref('')

const extInbox = ref([
  { id: 1, from: 'supplier_a@example.com', fromName: '供应商A', to: 'user@company.com', avatar: 'A', avatarColor: '#3b82f6', subject: '报价单 - 2026Q3材料采购', preview: '附件是本季度材料报价单，请查收...', time: '10:00', fullTime: '2026-06-11 10:00', read: false, body: '<p>您好，</p><p>附件是本季度（2026Q3）材料报价单，请查收。</p><p>如有任何疑问，请随时联系。</p><p>谢谢！</p>', attachments: ['报价单_Q3.xlsx'] },
  { id: 2, from: 'client@partner.com', fromName: '合作方', to: 'user@company.com', avatar: '合', avatarColor: '#10b981', subject: '关于项目进度的确认', preview: '我们已经完成了项目第一阶段的验收...', time: '昨天', fullTime: '2026-06-10 15:30', read: false, body: '<p>您好，</p><p>我们已经完成了项目第一阶段的验收工作，相关报告已上传。</p><p>请确认并安排第二阶段的启动会议。</p>', attachments: [] },
  { id: 3, from: 'newsletter@industry.com', fromName: '行业资讯', to: 'user@company.com', avatar: '资', avatarColor: '#8b5cf6', subject: '制造业数字化转型白皮书', preview: '最新发布的制造业数字化转型白皮书...', time: '周二', fullTime: '2026-06-09 09:00', read: true, body: '<p>最新发布的《制造业数字化转型白皮书》已可下载。</p>', attachments: ['白皮书.pdf'] }
])
const extSent = ref([
  { id: 101, from: 'user@company.com', to: 'supplier_a@example.com', toName: '供应商A', avatar: '我', avatarColor: '#6366f1', subject: 'Re: 报价单', preview: '收到，我们会尽快审核...', time: '11:00', fullTime: '2026-06-11 11:00', read: true, body: '<p>收到报价单，我们会尽快审核并回复。</p>' }
])
const extDrafts = ref([])
const extSpam = ref([{ id: 301, from: 'spam@ads.com', to: 'user@company.com', avatar: 'S', avatarColor: '#9ca3af', subject: '【推广】限时优惠活动', preview: '点击查看详情...', time: '06-08', fullTime: '2026-06-08', read: true, body: '<p>这是垃圾邮件。</p>' }])

const currentMails = computed(() => {
  switch (folder.value) { case 'inbox': return extInbox.value; case 'sent': return extSent.value; case 'drafts': return extDrafts.value; case 'spam': return extSpam.value; default: return extInbox.value }
})
const filteredMails = computed(() => {
  if (!searchQuery.value) return currentMails.value; const q = searchQuery.value.toLowerCase()
  return currentMails.value.filter(m => m.subject.toLowerCase().includes(q) || m.from.toLowerCase().includes(q))
})

const fetchMails = () => { fetching.value = true; setTimeout(() => { fetching.value = false; lastFetch.value = new Date().toLocaleTimeString(); $message.success('已从 POP3 服务器获取 3 封新邮件（模拟）') }, 1500) }
const openMailDetail = (m) => { if (folder.value === 'inbox') m.read = true; selectedMail.value = m }
const replyMail = (m) => { $message.info('回复: ' + m.subject) }
const forwardMail = (m) => { $message.info('转发: ' + m.subject) }
const deleteMail = async (m) => {
  if (!await $confirm('确定删除？')) {
    extSpam.value.push(m)
    if (folder.value === 'inbox') extInbox.value = extInbox.value.filter(x => x.id !== m.id)
    else if (folder.value === 'sent') extSent.value = extSent.value.filter(x => x.id !== m.id)
    selectedMail.value = null
  }
}
</script>

<style scoped>
.view-container { background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); overflow: hidden; max-height: calc(100vh - 110px); }
.mail-layout { display: flex; height: calc(100vh - 115px); }
.folder-panel { flex: 0 0 200px; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; background: #fafbfc; }
.panel-header { padding: 16px; }
.folder-list { flex: 1; padding: 4px 0; }
.folder-item { display: flex; align-items: center; gap: 10px; padding: 10px 16px; cursor: pointer; font-size: 13px; color: #374151; transition: all 0.15s; }
.folder-item:hover { background: #f3f4f6; }
.folder-item.active { background: #fef3c7; color: #d97706; font-weight: 500; }
.folder-item i { width: 18px; text-align: center; font-size: 14px; }
.folder-count { margin-left: auto; background: #e5e7eb; color: #6b7280; padding: 1px 7px; border-radius: 10px; font-size: 11px; }
.fetch-section { padding: 12px 16px; border-top: 1px solid #e5e7eb; }
.fetch-status { font-size: 10px; color: #9ca3af; text-align: center; margin-top: 6px; }
.mail-list-panel { flex: 0 0 320px; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; }
.list-header { padding: 10px 12px; border-bottom: 1px solid #e5e7eb; }
.form-control-sm { width: 100%; padding: 6px 10px; border: 1px solid #e5e7eb; border-radius: 4px; font-size: 12px; box-sizing: border-box; }
.mail-list { flex: 1; overflow-y: auto; }
.mail-item { display: flex; align-items: center; gap: 10px; padding: 10px 12px; border-bottom: 1px solid #f9fafb; cursor: pointer; transition: background 0.15s; }
.mail-item:hover { background: #f8fafc; }
.mail-item.selected { background: #fef3c7; }
.mail-item.unread { background: #fffdf5; }
.mail-avatar { width: 36px; height: 36px; border-radius: 6px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 13px; font-weight: 600; flex-shrink: 0; }
.mail-avatar.large { width: 56px; height: 56px; font-size: 20px; }
.mail-info { flex: 1; min-width: 0; }
.mail-top { display: flex; justify-content: space-between; margin-bottom: 2px; }
.mail-from { font-size: 12px; font-weight: 600; color: #1f2937; }
.mail-time { font-size: 10px; color: #9ca3af; }
.mail-subject { font-size: 12px; color: #374151; margin-bottom: 2px; }
.mail-preview { font-size: 11px; color: #9ca3af; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.unread-dot { width: 7px; height: 7px; border-radius: 50%; background: #f59e0b; flex-shrink: 0; }
.empty-list { text-align: center; padding: 40px 16px; color: #9ca3af; font-size: 12px; line-height: 1.5; }
.mail-detail-panel { flex: 1; display: flex; flex-direction: column; min-width: 0; overflow-y: auto; }
.empty-detail { align-items: center; justify-content: center; }
.empty-state { text-align: center; color: #d1d5db; }
.empty-state i { font-size: 48px; margin-bottom: 12px; }
.empty-state p { font-size: 14px; }
.detail-header { display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; border-bottom: 1px solid #e5e7eb; background: #fafbfc; }
.detail-header h4 { margin: 0; font-size: 16px; color: #1f2937; }
.close-btn { background: none; border: none; font-size: 20px; color: #9ca3af; cursor: pointer; }
.close-btn:hover { color: #374151; }
.detail-meta { display: flex; gap: 16px; padding: 16px 20px; border-bottom: 1px solid #f3f4f6; background: #f9fafb; }
.meta-info { flex: 1; }
.meta-row { padding: 3px 0; font-size: 12px; color: #6b7280; }
.meta-row label { font-weight: 500; color: #374151; }
.attach-list { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 4px; }
.attach-item { background: #f3f4f6; padding: 4px 10px; border-radius: 4px; font-size: 11px; color: #374151; }
.detail-body { padding: 20px; flex: 1; font-size: 13px; line-height: 1.8; color: #374151; }
.detail-actions { padding: 12px 20px; border-top: 1px solid #e5e7eb; display: flex; gap: 8px; background: #fafbfc; }
.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s; }
.btn-primary { background: #f59e0b; color: #fff; border-color: #f59e0b; }
.btn-primary:hover { background: #d97706; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-danger { background: #ef4444; color: #fff; border-color: #ef4444; }
.btn-danger:hover { background: #dc2626; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
